module.exports = __webpack_public_path__ + "static/alice-walker-41699d5e9cfa97685f426a4b126ac7fc.jpg";